import { NavLink } from "react-router-dom";

const Header = () => {
  return (
    <>
      {/* Header start */}
      <nav className="navbar navbar-expand-lg navbar-custom">
        <div className="container">
          {/* <a className="navbar-brand me-4" href="#">
            BookOnNile
          </a> */}
          <img className="bg-white" src="/assets/img/BookOnNile Logo.svg" alt="bonlogo" style={{ width: "4rem", padding: "4px" }} />
          <button
            className="navbar-toggler border-0"
            data-bs-target="#navMenu"
            data-bs-toggle="collapse"
            type="button"
          >
            <span className="navbar-toggler-icon" style={{ filter: "invert(1)" }} />
          </button>
          <div className="collapse navbar-collapse" id="navMenu">
            <ul className="navbar-nav me-auto">
              <li className="nav-item">
                <NavLink to="/" className="nav-link active">
                  <i className="bi bi-buildings me-1" />
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/Property/Login" className="nav-link ">
                  <i className="bi bi-buildings me-1" />
                  Property
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/Reservation/login" className="nav-link" >
                  <i className="bi bi-calendar-check me-1" />
                  Reservation
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/Agent/login" className="nav-link" >
                  <i className="bi bi-person-badge me-1" />
                  Agent
                </NavLink>
              </li>
            </ul>
            <div className="d-flex align-items-center gap-2 mt-2 mt-lg-0">
              <button className="zzx_btn-signin">Sign in</button>
              <button className="zzx_btn-register">Register</button>
            </div>
          </div>
        </div>
      </nav>

      {/* Header end */}

    </>
  );
};

export default Header;
